import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SettingsIcon from '@mui/icons-material/Settings'
import { useCurrentUser } from '../../shared/hooks/useCurrentUser'
import FeatureActionsMenu from './components/FeatureActionsMenu'
import TenantOperationDialog from './components/TenantOperationDialog'
import TenantListDialog from './components/TenantListDialog'
import FeatureToggleSnackbar from './components/FeatureToggleSnackbar'
import { useFeatureTogglesQuery } from './useFeatureToggle'
import { useFeatureTenantActions } from './useFeatureTenantActions'
import { sortByName } from './featureToggleUtils'

function FeatureTogglePage() {
  const navigate = useNavigate()
  const { allowedToManageFeature } = useCurrentUser()
  const { features, isLoading } = useFeatureTogglesQuery('PUBLIC')
  const { openMenu, menuProps, tenantDialogProps, listDialogProps, snackbar, handleSnackbarClose, busy } =
    useFeatureTenantActions()

  const sortedFeatures = sortByName(features)

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" component="h2">
          Feature Toggle
        </Typography>
        {allowedToManageFeature && (
          <Button
            variant="outlined"
            startIcon={<SettingsIcon />}
            onClick={() => navigate('/workspace/feature-toggle/admin')}
          >
            Gerenciar features
          </Button>
        )}
      </Box>

      <Paper variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Nome</strong>
              </TableCell>
              <TableCell>
                <strong>Descrição</strong>
              </TableCell>
              <TableCell>
                <strong>Ações</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedFeatures.map((item) => (
              <TableRow key={item.name}>
                <TableCell>{item.name}</TableCell>
                <TableCell>{item.description}</TableCell>
                <TableCell>
                  <IconButton
                    size="small"
                    aria-label={`Ações: ${item.name}`}
                    onClick={(event) => openMenu(event, item)}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {!isLoading && sortedFeatures.length === 0 && (
              <TableRow>
                <TableCell colSpan={3}>Nenhuma feature encontrada.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      <FeatureActionsMenu {...menuProps} />
      <TenantOperationDialog {...tenantDialogProps} />
      <TenantListDialog {...listDialogProps} />

      {busy && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}

      <FeatureToggleSnackbar snackbar={snackbar} onClose={handleSnackbarClose} />
    </Box>
  )
}

export default FeatureTogglePage
